import { useHistory } from "react-router";
import React, { useState } from "react";
/** @jsxImportSource @emotion/react */
import tw, { styled } from "twin.macro";
import intro_overlay from "../../assets/images/intro_overlay.png";
import intro_pics from "../../assets/images/intro_pics.png";
import app_logo_pink from "../../assets/svg/app_logo_pink.svg";
import boy_girl from "../../assets/svg/boy_girl.svg";
import couples from "../../assets/svg/love_struck.svg";
import guest from "../../assets/svg/wedding_guest.svg";
import { CouplesIntro, Loading, PageLoading } from "../../components";
import { btnStyle, hideScrollbar } from "../../lib/styles/styleLibrary";
import { ROUTES } from "../../settings/routes";
import bgSidebar from "../../assets/images/bg_sidebar.png";
import { switchExperience } from "../../redux/actions/wedding";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { useMutation } from "react-query";

const Wrapper = styled.div`
	${tw`m-0 p-0 bg-white flex flex-row flex-wrap`}
	height: 100vh !important;
	overflow: hidden !important;

	.intro-left {
		${tw`h-screen! w-full md:pl-16! md:pt-20! p-8! `}
		flex: 1;
		overflow-y: scroll;
		overflow-x: hidden;
		@media (max-width: 768px) {
			background: url(${bgSidebar});
			background-repeat: no-repeat;
			background-position: center;
			background-size: cover;
			background-blend-mode: multiply;
		}
	}

	.intro-right {
		${tw`h-screen! w-full m-0 p-0`}
		flex: 1;
		overflow: hidden !important;
		background: url(${intro_overlay});
		background-repeat: no-repeat;
		background-position: center;
		background-size: cover;
		background-blend-mode: multiply;
		@media (max-width: 768px) {
			display: none;
		}
	}
`;

const CardWrapper = styled.div`
	${tw`shadow rounded-3xl w-56 h-auto bg-white cursor-pointer m-2`}
	${({ hasBorder }) =>
		hasBorder && tw`border-2 border-appPink! border-solid shadow-lg`}
`;

const AccountSetup = (props) => {
	const history = useHistory();
	const [flow, setFlow] = useState("welcome");
	const [experience, setExperience] = useState("couple");
	const [tog, setTog] = useState(true);


	const { mutateAsync: handleSwitch, isLoading: switchLoading } =
		useMutation(switchExperience);
	const handleSelect = async () => {
		if (isEmpty(experience)) {
			Toast.fire({
				icon: "error",
				title: `Please select an experience, Couples or Guest`,
			});
			return;
		}
		const data = {
			experience,
		};
		try {
			const response = await handleSwitch(data);
			console.log("\nswitch experience res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				return Toast.fire({
					icon: "error",
					title: response.data.message,
				});
			}
			setTimeout(() => {
				if (!hasError) {
					experience === "couple"
						? setFlow("setup")
						: history.push({ pathname: ROUTES.DASHBOARD });
				}
			}, 1000);
		} catch (err) {
			// console.log("Error: ", err);
		}
	};

	const handleFlow = (val) => {
		setFlow(val);
	};

	return (
		<Wrapper className={props.className}>
			{switchLoading && <PageLoading />}
			<div className="intro-left" css={{ hideScrollbar }}>
				<div tw="mb-12">
					{" "}
					<img
						src={app_logo_pink}
						alt="Wedding Story"
						tw="w-auto h-auto"
					/>
				</div>
				{/* Welcome screen */}
				{flow === "welcome" && (
					<div tw="w-full flex flex-col justify-center md:justify-start">
						<div tw="flex flex-row flex-wrap items-center">
							<h1 tw="text-5xl font-bold mr-3 pt-6">Welcome</h1>
							<img src={boy_girl} alt="" tw="w-48 h-24" />
						</div>
						<div tw="pt-5">
							<p tw="text-lg font-semibold">
								Love is a beautiful thing. <br />
								To customize this experience, <br />
								<span tw="text-appPink">
									{" "}
									tell us who you are.
								</span>
							</p>
						</div>
						<div tw="pt-5 flex flex-row flex-wrap">
							<CardWrapper
								hasBorder={tog}
								tw="md:ml-0! ml-2"
								onClick={() => {
									setTog(true);
									setExperience("couple");
								}}>
								<div tw="p-5">
									<div tw="h-36">
										<img
											src={couples}
											tw="mb-2 rounded-md"
											alt="Couples"
										/>
									</div>

									<p tw="mb-4 font-semibold text-center text-xl leading-loose">
										Wedding couple
									</p>
								</div>
							</CardWrapper>
							<CardWrapper
								hasBorder={!tog}
								onClick={() => {
									setTog(false);
									setExperience("guest");
								}}>
								<div tw="p-5">
									<div tw="h-36">
										<img
											src={guest}
											tw="mb-2 rounded-md"
											alt="Guests"
										/>
									</div>

									<p tw="mb-4 font-semibold text-center text-xl leading-loose">
										Wedding guest
									</p>
								</div>
							</CardWrapper>
						</div>
						<div tw="pt-8 mb-8 flex flex-col sm:w-full md:w-full xl:w-8/12 lg:w-9/12">
							<button
								css={btnStyle}
								onClick={handleSelect}
								disabled={switchLoading}>
								{switchLoading ? <Loading /> : "Continue"}
							</button>
						</div>
					</div>
				)}

				{/* Profile setup screen */}
				{flow === "setup" && <CouplesIntro handleFlow={handleFlow} />}
			</div>
			<div className="intro-right">
				<img src={intro_pics} alt="" tw="h-full w-full" />
			</div>
		</Wrapper>
	);
};

export default AccountSetup;
